import { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/plan",
    name: "PlanPage",
    meta: {
      layout: "default",
    },
    component: () => import("@/modules/Plan/pages/PIndex.vue"),
  },
] as RouteRecordRaw[];
